module.exports = __webpack_public_path__ + "static/media/laughing.46672823.png";